const Money = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.63636 4H22V16H5.63636V4ZM13.8182 7C14.5415 7 15.2352 7.31607 15.7467 7.87868C16.2581 8.44129 16.5455 9.20435 16.5455 10C16.5455 10.7956 16.2581 11.5587 15.7467 12.1213C15.2352 12.6839 14.5415 13 13.8182 13C13.0949 13 12.4012 12.6839 11.8897 12.1213C11.3782 11.5587 11.0909 10.7956 11.0909 10C11.0909 9.20435 11.3782 8.44129 11.8897 7.87868C12.4012 7.31607 13.0949 7 13.8182 7ZM9.27273 6C9.27273 6.53043 9.08117 7.03914 8.74019 7.41421C8.39922 7.78929 7.93676 8 7.45455 8V12C7.93676 12 8.39922 12.2107 8.74019 12.5858C9.08117 12.9609 9.27273 13.4696 9.27273 14H18.3636C18.3636 13.4696 18.5552 12.9609 18.8962 12.5858C19.2371 12.2107 19.6996 12 20.1818 12V8C19.6996 8 19.2371 7.78929 18.8962 7.41421C18.5552 7.03914 18.3636 6.53043 18.3636 6H9.27273ZM2 8H3.81818V18H18.3636V20H2V8Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Money;
